export enum Breakpoint {
  small = 0,
  medium = 640,
  large = 1024,
  xlarge = 1200,
  xxlarge = 1440
}

export function breakpointUp(Breakpoint) : boolean {
  const w: number = window.innerWidth;
  if (w > Breakpoint) {
    return true;
  }
  return false
}
